import { Language } from '@/types/language';

export const languageCodeMapping: Record<string, Language> = {
  fa: Language.Farsi,
  en: Language.English,
  ar: Language.Arabic,
  pa: Language.Pashto,
};

export const getLanguageFromCode = (code: keyof typeof languageCodeMapping): Language => {
  const language = languageCodeMapping[code];
  if (!language) {
    throw new Error(`Unsupported language code: ${code}`);
  }
  return language;
};